// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
//promise等支持
import 'babel-polyfill'

import Vue from 'vue'
import router from './router'



//element
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

//toggle-button
import ToggleButton from 'vue-js-toggle-button'
Vue.use(ToggleButton)

// import BaiduMap from 'vue-baidu-map'
// Vue.use(BaiduMap, {
//   // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
//   ak: "ZbnsvsDDco2e9gHLAPcgeAiY4zFDhQng",
// });

import './assets/scss/reset.scss'
import './assets/scss/base.scss'
import './assets/scss/global.scss'
import './assets/css/iconfont.css'


import {Axios} from '@/fetch/index'
Vue.prototype.$http = Axios

Vue.config.productionTip = false

//全局混入
import config from './default_config'
import utils from './util/index'

Vue.mixin({
  data(){
    return{
      ...config
    }
  },
  methods:{
    //工具方法
    ...utils
  }
})

/* eslint-disable no-new */
import App from './App'
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js